import { getRoot, Instance, types } from 'mobx-state-tree';
import { RootType } from '../../../rootInstance';
import {
  QuizListElementModel,
  QuizListElementModelType,
} from './QuizListElementModel';

export const QuizListModel = types
  .model({
    rows: types.array(QuizListElementModel),
  })
  .views((self) => {
    return {
      get root(): RootType {
        return getRoot(self);
      },
      get elements(): QuizListElementModelType[] {
        return Array.from(self.rows.values()).slice().reverse();
      },
    };
  })
  .actions((self) => {
    return {
      setElements(items: QuizListElementModelType[]) {
        self.rows.replace(items);
      },
    };
  })
  .named('QuizListModel');

export type QuizListModelType = Instance<typeof QuizListModel>;
